import React from 'react';

import { Cards, CountryPicker, Chart } from './components';
import { fetchData } from './api/';
import styles from './App.module.css';


class App extends React.Component {
  state = {
    data: {},
    country: '',
  }

  async componentDidMount() {
    const data = await fetchData();

    this.setState({ data });
  }

  handleCountryChange = async (country) => {
    const data = await fetchData(country);

    this.setState({ data, country: country });
  }

  render() {
    const { data, country } = this.state;

    return (
      <div className={styles.container}>
      <div class="container-fluid bg-warning p-5 text-center my-3">
    <h1  class="text-white text-center">COVID-19 Tracker</h1>
    <h5 class="text-muted">
      Keep track of all the COVID-19 cases around the
      world.
    </h5>
  </div>
        
        <Cards data={data} />
        <CountryPicker handleCountryChange={this.handleCountryChange} />
        <Chart data={data} country={country} /> 
        <div className=" py-4">
          <a href="https://covid19-tarckerindia.netlify.app/"  className="btn btn-success btn-lg">View Detailed Report on India</a>
          </div>
        <div class="container-fluid bg-dark p-3 text-center my-3s">
          
        
        <div class="container">

          <div>
          <h5 class="text text-white text-center py-2">
        Let us be Social..!!
      </h5>
          </div>

        


<ul class="list-unstyled list-inline text-center">
  <li class="list-inline-item">
    <a href="https://www.linkedin.com/in/ragul-vinay/" class="btn-floating btn-li mx-1">
      <i class="fab fa-linkedin"></i>
    </a>
  </li>
  <li class="list-inline-item">
    <a href="https://instagram.com/ragul_vinay?igshid=y02v9i64lrrs" class="btn-floating btn-tw mx-1">
      <i class="fab fa-instagram-square"> </i>
    </a>
  </li>
  <li class="list-inline-item">
    <a href="https://www.facebook.com/ragul.vinay" class="btn-floating btn-fb mx-1">
      <i class="fab fa-facebook-square"> </i>
    </a>
  </li>
  <li class="list-inline-item">
    <a href="https://mobile.twitter.com/VinayRagul" class="btn-floating btn-tw mx-1">
      <i class="fab fa-twitter-square"> </i>
    </a>
  </li>
  
  
  
 
  
</ul>


</div>
      
      <h5 class="text-muted">
        Developed by | <span className="text text-white" >Ragul Vinay</span>
      </h5>
    </div>
        

      </div>
      
    );
  }
}

export default App;